export const accountCircleIcon = new URL(`./icons/account_circle.svg`, import.meta.url).href;
export const activeIcon = new URL('./icons/active-icon.svg', import.meta.url).href;
export const actionsIcon = new URL('./icons/contextual-icon.svg', import.meta.url).href;
export const anomaliesHandledIcon = new URL('./icons/anomalies-handled-icon.svg', import.meta.url).href;
export const anomaliesHSCodeOrDescriptionIcon = new URL('./icons/anomaly-hs-code-icon.svg', import.meta.url).href;
export const anomalyValueIcon = new URL('./icons/anomaly-value-icon.svg', import.meta.url).href;
export const archiveIcon = new URL('./icons/archive-icon.svg', import.meta.url).href;
export const arrowDownIcon = new URL('./icons/arrow-down.svg', import.meta.url).href;
export const dropdownArrowUpIcon = new URL('./icons/dropdown-arrow-up.svg', import.meta.url).href;
export const dropdownArrowDownIcon = new URL('./icons/dropdown-arrow-down.svg', import.meta.url).href;
export const arrowUpIcon = new URL('./icons/arrow-up.svg', import.meta.url).href;
export const backIcon = new URL('./icons/back-icon.svg', import.meta.url).href;
export const blueCheckMarkIcon = new URL('./icons/blue-check-mark.svg', import.meta.url).href;
export const lockIcon = new URL('./icons/lock-icon.svg', import.meta.url).href;
export const calendarIcon = new URL('./icons/calendar-icon.svg', import.meta.url).href;
export const checkMarkIcon = new URL('./icons/check-mark.svg', import.meta.url).href;
export const cleanupIcon = new URL('./icons/cleanup-icon.svg', import.meta.url).href;
export const commentIcon = new URL('./icons/comment-icon.svg', import.meta.url).href;
export const closeIcon = new URL('./icons/close-icon.png', import.meta.url).href;
export const copyIcon = new URL('./icons/copy.svg', import.meta.url).href;
export const customsProcessingIcon = new URL('./icons/customs-processing-icon.svg', import.meta.url).href;
export const customsSyncIcon = new URL('./icons/customs-sync-icon.svg', import.meta.url).href;
export const dangerIcon = new URL('./icons/danger-action.svg', import.meta.url).href;
export const deleteIcon = new URL('./icons/trash-icon.svg', import.meta.url).href;
export const documentIcon = new URL('./icons/document-icon.svg', import.meta.url).href;
export const downloadIcon = new URL('./icons/download-icon.svg', import.meta.url).href;
export const errorIcon = new URL('./icons/error-icon.svg', import.meta.url).href;
export const failedIcon = new URL('./icons/status-failed-icon.svg', import.meta.url).href;
export const finalizeIcon = new URL('./icons/finalize-batch.svg', import.meta.url).href;
export const greenRejectedIcon = new URL('./icons/green-rejected-icon.svg', import.meta.url).href;
export const inactiveIcon = new URL('./icons/inactive-icon.svg', import.meta.url).href;
export const inspectIcon = new URL('./icons/inspect-icon.svg', import.meta.url).href;
export const invalidatedIcon = new URL('./icons/status-invalidated.svg', import.meta.url).href;
export const layerMultipleIcon = new URL('./icons/layer-multiple.svg', import.meta.url).href;
export const leftArrowIcon = new URL('./icons/left-arrow.svg', import.meta.url).href;
export const rightArrowIcon = new URL('./icons/right-arrow.svg', import.meta.url).href;
export const lightGreenSuccessIcon = new URL('./icons/light-green.svg', import.meta.url).href;
export const mailIcon = new URL('./icons/mail.svg', import.meta.url).href;
export const noSentAnomaliesIcon = new URL('./icons/not-sent-no-anomalies-icon.svg', import.meta.url).href;
export const notesIcon = new URL('./icons/notes.svg', import.meta.url).href;
export const notReleasedIcon = new URL('./icons/status-not-released-icon.svg', import.meta.url).href;
export const notSentIcon = new URL('./icons/status-not-sent-icon.svg', import.meta.url).href;
export const processingIcon = new URL('./icons/status-processing-icon.svg', import.meta.url).href;
export const refactorIcon = new URL('./icons/refactor.svg', import.meta.url).href;
export const refreshIcon = new URL('./icons/refresh-icon.svg', import.meta.url).href;
export const rejectedIcon = new URL('./icons/status-rejected-icon.svg', import.meta.url).href;
export const releasedIcon = new URL('./icons/status-released-icon.svg', import.meta.url).href;
export const reportIcon = new URL('./icons/report-icon.svg', import.meta.url).href;
export const riskAnalysisReportIcon = new URL('./icons/risk-analysis-report-icon.svg', import.meta.url).href;
export const searchIcon = new URL('./icons/search-icon.svg', import.meta.url).href;
export const sendIcon = new URL('./icons/action-icon.svg', import.meta.url).href;
export const rotatedSendIcon = new URL('./icons/rotated-action-icon.svg', import.meta.url).href;
export const sendingIcon = new URL('./icons/sending-icon.svg', import.meta.url).href;
export const sendRiskAnalysisToCustomerIcon = new URL('./icons/send-risk-analysis-to-customer-icon.svg', import.meta.url).href;
export const translationIcon = new URL('./icons/translation-icon.svg', import.meta.url).href;
export const updateIcon = new URL('./icons/update-icon.svg', import.meta.url).href;
export const uploadFileIcon = new URL('./icons/upload-file-icon.png', import.meta.url).href;
export const uploadIcon = new URL('./icons/upload-icon.svg', import.meta.url).href;
export const viewIcon = new URL('./icons/view-icon.svg', import.meta.url).href;
export const viewImageIcon = new URL('./icons/picture.svg', import.meta.url).href;
export const revokeIcon = new URL('./icons/revoke-icon.svg', import.meta.url).href;

export const IconFactory = {
  accountCircle: accountCircleIcon,
  active: activeIcon,
  actions: actionsIcon,
  anomaliesHandled: anomaliesHandledIcon,
  anomaliesHSCodeOrDescription: anomaliesHSCodeOrDescriptionIcon,
  anomalyValue: anomalyValueIcon,
  archive: archiveIcon,
  arrowDown: arrowDownIcon,
  dropdownArrowDown: dropdownArrowDownIcon,
  dropdownArrowUp: dropdownArrowUpIcon,
  arrowUp: arrowUpIcon,
  back: backIcon,
  blueCheckMark: blueCheckMarkIcon,
  lock: lockIcon,
  calendar: calendarIcon,
  checkMark: checkMarkIcon,
  cleanup: cleanupIcon,
  comment: commentIcon,
  close: closeIcon,
  copy: copyIcon,
  customsProcessing: customsProcessingIcon,
  customsSync: customsSyncIcon,
  danger: dangerIcon,
  delete: deleteIcon,
  document: documentIcon,
  download: downloadIcon,
  error: errorIcon,
  failed: failedIcon,
  finalize: finalizeIcon,
  greenRejected: greenRejectedIcon,
  inactive: inactiveIcon,
  inspect: inspectIcon,
  invalidated: invalidatedIcon,
  layerMultiple: layerMultipleIcon,
  leftArrow: leftArrowIcon,
  rightArrow: rightArrowIcon,
  lightGreenSuccess: lightGreenSuccessIcon,
  mail: mailIcon,
  noSentAnomalies: noSentAnomaliesIcon,
  notes: notesIcon,
  notReleased: notReleasedIcon,
  notSent: notSentIcon,
  processing: processingIcon,
  refactor: refactorIcon,
  refresh: refreshIcon,
  rejected: rejectedIcon,
  released: releasedIcon,
  report: reportIcon,
  riskAnalysisReport: riskAnalysisReportIcon,
  search: searchIcon,
  send: sendIcon,
  rotatedSend: rotatedSendIcon,
  sending: sendingIcon,
  sendRiskAnalysisToCustomer: sendRiskAnalysisToCustomerIcon,
  translation: translationIcon,
  update: updateIcon,
  upload: uploadIcon,
  view: viewIcon,
  viewImage: viewImageIcon,
  revoke: revokeIcon,
};
